import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/smooth";

const LINKS = [
  { id: "dimora", label: "La Casa" },
  { id: "spazi", label: "Gli Spazi" },
  { id: "galleria", label: "Galleria" },
  { id: "spa", label: "Giardino & SPA" },
  { id: "disponibilita", label: "Disponibilità" },
  { id: "dintorni", label: "Dintorni" },
  { id: "host", label: "L'Host" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled ? "bg-linen/85 backdrop-blur-xl shadow-[0_1px_0_rgba(28,25,23,0.08)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`font-serif text-lg tracking-tight transition-colors duration-500 ${scrolled ? "text-stone-900" : "text-linen"}`}
        >
          Saint <span className="italic text-oro">Anthony</span>
        </button>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className={`text-xs font-medium uppercase tracking-[0.18em] transition-colors duration-300 hover:text-oro ${
                scrolled ? "text-stone-600" : "text-linen/80"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-book-now-btn"
            onClick={() => go("prenota")}
            className="rounded-full bg-terracotta px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-linen transition-transform duration-300 hover:scale-[1.04] hover:bg-[#9C5B41] active:scale-95"
          >
            Prenota
          </button>
          <button
            data-testid="nav-mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className={`lg:hidden ${scrolled ? "text-stone-900" : "text-linen"}`}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25 }}
            className="border-t border-stone-200/60 bg-linen/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col px-6 py-4">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="border-b border-stone-200/50 py-3 text-left font-serif text-lg text-stone-800"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
